module.exports = __webpack_public_path__ + "static/media/landingpage.93a9c111.png";